import "./Search.css";

import { useState, useRef } from "react";
import {useRcd, regUses, useRcds, getRcdById, randomUUID, useTblDef} from "../../axios_with_token";
import { useRcdEditDialog } from "../../input_types/Dialog/Dialog";
import Tree from "../../components/Tree/Tree";

export default function Search({fldName, form, fldDef, opts:optsIn}){
    const refData = useRef({
        init: false,
        curRcdId: []
    });
    const [refreshId, setRefreshId] = useState(0);
    const refresh = _=> setRefreshId(refreshId+1);

    const opts = optsIn || {};
    const {onChange, ...rest} = form.register(fldName, {required: 1})

    const [tblName, setTblName] = useState(fldDef.srcTbl);
    // const tblName = fldDef.srcTbl;
    const [searchFlds, setSearchFlds] =  useState(fldDef.srcSearchFlds || '');
    const [showFlds, setShowFlds] = useState(fldDef.srcShowFlds.split(',').map(fldName=>fldName.trim()).filter(a=>a));
    // const showFlds = fldDef.srcShowFlds.split(',').map(fldName=>fldName.trim()).filter(a=>a);
    const [showType, setShowType] = useState(fldDef.srcShowType || "list");
    // const showType = fldDef.srcShowType || "list"; //tree

    const {regUse, DefaultResponse} = regUses();

    const refInput = useRef();
    const refSuggests = useRef();
    const [input, setInput] = useState('');
    const [page, setPage] = useState(0);
    const {data:tblDef} = regUse(useTblDef(fldDef.srcTbl))

    // const filters = [{
    //     __filtersRelation: 'any',
    //     __filterFlds: {},
    // }];
    // searchFlds.split(',').filter(a=>a).forEach(fldName=>{
    //     // `.*(${showType=='tree'?"":input}).*`
    //     filters[0].__filterFlds[fldName] = showType=='tree'?"":input;
    // })

    const filters = [{
        __commonFlds:searchFlds,
        __commonFilters: showType=='tree'?"":input
    }];

    // console.log('search filter:', filters);
    const {data:dataSuggests} = regUse(useRcds(tblName, page, fldDef.srcShowType=='tree'?9999:opts.rcdsPerPage, filters, {
        reset: input
    }));
    
    const {data:curRcd} = regUse(useRcd(fldDef.srcTbl, form.getValues()[fldName]));
    const {Dialog:DlgNew, openDialog:openDlgNew, closeDialog} = regUse(useRcdEditDialog({
        dlgTitle: "new",
        tblName, 
        rcdId:null,
        onSaved: _=>{
            // [] after new rcd added, refresh suggest
            //  currently, after adding new rcd, you must change input to get new added rcd in suggests
                setInput('');
                setPage(0);
                opts.onDataChanged&&opts.onDataChanged();
        },
        curValues: opts.curValues || {}
    }));
    const {Dialog:DlgEdit, openDialog:openDlgEdit, closeDialogEdite, setRcdId:setEditRcdId} = regUse(useRcdEditDialog({
        dlgTitle: "edit",
        tblName, 
        rcdId: null,
        onSaved: _=>{
            // [] after new rcd added, refresh suggest
            //  currently, after adding new rcd, you must change input to get new added rcd in suggests
                setInput('');
                setPage(0);
                opts.onDataChanged&&opts.onDataChanged();
        },
        // curValues: opts.curValues || {}
    }));
    
    const setInputCaption = caption=>{
        if(refInput.current){
            refInput.current.value = caption;
            refInput.current.caption = caption;
            refInput.current.title = `${fldName}: ${caption}`;
        };
    };

    const selectOpts = ((dataSuggests||{}).rcds || []);
    const mkInputCaption = (rcd, showFlds)=>{
        return showFlds.map(fldName=>rcd[fldName]).filter(a=>a).join(' / ')
    }

    if(!refData.current.init && curRcd){
        refData.current.init = true;

        if(refInput.current)setInputCaption(mkInputCaption(curRcd, showFlds));
    }

    const maxPage =  Math.ceil(((dataSuggests||{}).rcdCnt||0)/10)-1;
    // const curVal = (curRcd||{}).__id;

    if(!form._ww_org_setvalue){
        form._ww_org_setvalue = form.setValue;
        form._ww_setvalue_cb_pool = [];
        form.setValue = function(fldName, fldValue){
            const fnPool = form._ww_setvalue_cb_pool || [];
            fnPool.forEach(fn=>fn({fldName, fldValue, form}));
            return form._ww_org_setvalue(...arguments);
        }
    }

    form._ww_setvalue_cb_pool.push(({fldName:fldNameIn, fldValue:fldValueIn, form})=>{
        if(fldNameIn == fldName && fldValueIn && tblName){
            getRcdById(tblName, fldValueIn).then(r=>{
                setInputCaption(mkInputCaption(r, showFlds));
            })
        }
    })

    // [depend search]
    const dependOn = fldDef.dependOn;
    if(dependOn){
        // [base set]


        // [settings format]
        // dependOn:{
        //     fld: 'for',
        //     tbls:{
        //         'orders': {
                        // tbl: 'orders',
                        // searchFlds: 'date,sn',
                        // showFlds: 'date,sn',
                        // // filter: {}
        //         }
        //     }
        // }
        form._ww_setvalue_cb_pool.push(({fldName:fldNameDependOn, fldValue:fldDependOnValue, form})=>{
            if(fldNameDependOn == dependOn.fld){
                const dependOnTbls = dependOn.tbls;
                const tblDef = dependOnTbls[fldDependOnValue] || {};
                // if(tblDef)

                setTblName(tblDef.tbl||'');
                setSearchFlds(tblDef.searchFlds||'');
                // setSearchFilters();
                setShowFlds((tblDef.showFlds || '__id').split(',').map(fldName=>fldName.trim()).filter(a=>a));
                setShowType(tblDef.showType || "list");

                form._ww_org_setvalue(fldName, '');
                setInputCaption('');
                refresh();
            }
        })
    }

    return <div>
        <DlgNew></DlgNew>
        <DlgEdit></DlgEdit>
        <input className="form-control" type="hidden" {...rest} />
        <div className="searchInput">
            <div className="input-group flex-nowrap" role="group" aria-label="Basic example">
                <input className="form-control" 
                    placeholder={showType=="tree"?"Click to select...":"Click to search..." }
                    onBlur={evt=>{
                        evt.target.value = evt.target.caption;
                    }}
                    ref={refInput}
                    onChange={evt=>{
                        setInput(evt.target.value);
                        setPage(0);
                    }}
                />
                <button type="button" className="btn btn-sm btn-warning"
                    tabIndex={0}
                    onClick={
                        evt=>{
                            form.setValue(fldName, 0);
                            setInputCaption('');
                            setPage(0);
                            setInput('');
                            refInput.current&&refInput.current.focus();
                        }
                    }
                >X</button>
                {opts.allowNew&&<button type="button" className="btn btn-sm btn-primary"
                    onClick={evt=>{
                        // [] hide suggestions
                        evt.target.blur();
                        openDlgNew();
                    }}
                >+</button>}
                {opts.allowNew&&<button type="button" className="btn btn-sm btn-primary"
                    onClick={evt=>{
                        // [] hide suggestions
                        evt.target.blur();
                        setEditRcdId(form.getValues()[fldName]);
                        openDlgEdit();
                    }}
                >E</button>}
            </div>
            <div className="bg-body rounded border p-3 pt-2 shadow-sm suggests"
                onClick={
                    evt=>{
                        let value = evt.target.getAttribute("value");
                        // [] may clicked on other items within the suggest div, filter here
                        if(value===undefined || value===null)return;

                        let caption = evt.target.innerText;
                        // console.log('suggest click...', caption);
                
                        if(opts.allowMultiple){
                            if(!RegExp(`^(${value.split(',').map(a=>a.trim()).filter(a=>a).join('|')})$`).test(value)){
                                const newValue = [value, form.getValues()[fldName]].filter(a=>a).join(',');
                                form.setValue(fldName, newValue);
                                refData.current.curRcdId = newValue.split(',');
                            }
                        }else{
                            form.setValue(fldName, value);
                            refData.current.curRcdId = value.split(',');
                        }
                        // [] set caption
                        // console.log('caption:', caption);
                        setInputCaption(caption);
                        // console.log('refData.current.curRcdId:', refData.current.curRcdId);
                        // refresh();
                
                        evt.target.blur();
                        
                        form.__on_wgt_change&&form.__on_wgt_change(fldName, form);
                    }
                }
                style={{"zIndex":"999999999999999"}}
                tabIndex={0}
                ref={refSuggests}
            >
                <DefaultResponse>
                    {/* {JSON.stringify(filters)} */}

                    <div>
                        <span>( rcd count: {(dataSuggests||{}).rcdCnt} )  
                            page: {page+1} / {maxPage+1}
                            <a href="#nolink"
                                className="p-3 link-underline-opacity-0 link-body-emphasis text-underline-hover"
                                onClick={evt=>{
                                    setPage(Math.max(0, page-1));
                                    refSuggests.current&&refSuggests.current.focus();


                                }}
                            >&lt;</a>
                            <a href="#nolink"
                                className="link-underline-opacity-0 link-body-emphasis text-underline-hover"
                                onClick={evt=>{
                                    setPage(Math.min(page+1, maxPage));
                                    refSuggests.current&&refSuggests.current.focus();
                                }}
                            >&gt;</a>
                        </span>
                    </div>
                    {showType=="tree"?<Tree
                        rcds={selectOpts||[]}
                        curRcdId={false}
                        showFlds={showFlds.join(',')}
                        tblDef={tblDef}
                    />
                    :<ol
                        className="list-group"
                    >{(selectOpts||[]).map((opt,idx)=><li 
                        className={`${refData.current.curRcdId.indexOf(String(opt.__id))>=0?'active ':''}list-group-item`} 
                        key={opt.__id+'-'+opt.caption}
                    >
                        <span className="pe-1">{page*10+idx+1}.</span>
                        <a  href="#nolink"
                            role="button" 
                            className="link-underline-opacity-0 link-body-emphasis text-underline-hover"
                            value={opt.__id}
                            // onClick={evt=>console.log("link clicked")}
                        >{mkInputCaption(opt, showFlds)}</a>
                    </li>)}</ol>
                    }

                    
                    {/* {((dataSuggests||{}).rcds||[]).map(rcd=><div
                        key={rcd.__id}
                    >
                        {rcd.__id}/ {rcd.sn} / {rcd.name} / {rcd.brandAbbr} / {rcd.description}
                    </div>)} */}
                </DefaultResponse>
            </div>
        </div>
        {opts.allowMultiple&&<div className="container">
            {(form.getValues()[fldName]||'').split(',').map(rcdId=>rcdId.trim()).filter(a=>a).map(rcdId=>{
                return <div
                    className="row d-flex"
                    key={rcdId}
                >
                    <span className="col">{rcdId} </span>
                    <button 
                        className="btn btn-warning col"
                        style={{flex: 0}}
                        onClick={evt=>{
                            const val = form.getValues()[fldName] || "";
                            // form.setValue(fldName, val.split(",").map(a=>a.trim()).filter(a=>a).filter(v=>v!=rcdId).join(","));
                            // setInputCaption(val);
                        }}
                        type="button"
                    >delete</button>
                </div>;
            })}   
        </div>}
    </div>;

};